/**
 * React Query key factory — pedagogy / assessment / elearning keys.
 *
 * Référence centrale dans `queryKeys.ts` (barrel).
 */

const pedagogyReferentialsAll = ['pedagogyReferentials'] as const
const elearningAll = ['elearning'] as const
const assessmentAll = ['assessment'] as const

export const pedagogyKeys = {
    pedagogyReferentials: {
        all: pedagogyReferentialsAll,
        listByResource: (resource: string) =>
            [...pedagogyReferentialsAll, 'list', resource] as const,
        list: (resource: string, entityId: string) =>
            [...pedagogyReferentialsAll, 'list', resource, entityId] as const,
        usages: (resource: string, itemId: string, search?: string) =>
            [...pedagogyReferentialsAll, 'usages', resource, itemId, search ?? ''] as const,
        classificationTree: (entityId: string) =>
            [...pedagogyReferentialsAll, 'tree', entityId] as const,
        movePreview: (entityId: string, level: string, id: string, destLevel: string, destId: string) =>
            [...pedagogyReferentialsAll, 'movePreview', entityId, level, id, destLevel, destId] as const,
    },
    elearning: {
        all: elearningAll,
        list: (entityId: string, search?: string, statusFilter?: string) =>
            [...elearningAll, 'list', entityId, search, statusFilter] as const,
        detail: (id: string) =>
            [...elearningAll, 'detail', id] as const,
    },
    assessment: {
        all: assessmentAll,
        banks: (entityId: string, search?: string) =>
            [...assessmentAll, 'banks', entityId, search] as const,
        bankDetail: (id: string) =>
            [...assessmentAll, 'bank', id] as const,
        questions: (entityId: string, bankId?: string | null, questionType?: string | null, isEliminatory?: boolean | null, search?: string) =>
            [...assessmentAll, 'questions', entityId, bankId, questionType, isEliminatory, search] as const,
        questionDetail: (id: string) =>
            [...assessmentAll, 'question', id] as const,
        quizzes: (entityId: string) =>
            [...assessmentAll, 'quizzes', entityId] as const,
        quizDetail: (id: string) =>
            [...assessmentAll, 'quiz', id] as const,
        criteria: (entityId: string, search?: string, scaleType?: string, isActive?: boolean) =>
            [...assessmentAll, 'criteria', entityId, search, scaleType, isActive] as const,
        criterionDetail: (id: string) =>
            [...assessmentAll, 'criterion', id] as const,
        grids: (entityId: string, search?: string) =>
            [...assessmentAll, 'grids', entityId, search] as const,
        gridDetail: (id: string) =>
            [...assessmentAll, 'grid', id] as const,
    },
}
